var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataStatistics"},[_vm._m(0),_c('div',{staticClass:"cont-box2"},[(_vm.processedData)?_c('chartBar',{attrs:{"chartDate":_vm.processedData,"height":"250px","width":"100%"}}):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('img',{staticClass:"cion",attrs:{"src":require("@/assets/home/dateLeft-icon.png")}}),_c('span',[_vm._v("年龄段分布")])])
}]

export { render, staticRenderFns }